import { Link } from 'react-router-dom';
import CtaBand from './CtaBand';
import Seo from './Seo';
import { SITE, productDemoPath } from '../config/site';

export default function ProductPageLayout({ page }) {
  if (!page) return null;

  return (
    <>
      <Seo
        title={page.name}
        description={page.subheadline}
        path={`/products/${page.id}`}
      />

      <section
        className="product-page-hero"
        style={{ '--product-accent': page.accent, '--product-glow': page.accentGlow }}
      >
        <div className="product-page-hero__bg" aria-hidden="true" />
        <div className="container product-page-hero__inner">
          <div className="product-page-hero__content animate-in">
            <Link to="/products" className="product-page-hero__back">
              ← All products
            </Link>
            <p className="product-page-hero__eyebrow">{page.eyebrow}</p>
            <h1>{page.headline}</h1>
            <p className="product-page-hero__sub">{page.subheadline}</p>
            {page.handcrafted && (
              <p className="product-page-hero__crafted">
                <span aria-hidden="true">🇮🇳</span> {SITE.handcraftedTagline}
              </p>
            )}
            <div className="product-page-hero__actions">
              <Link to={productDemoPath(page.id)} className="btn btn--primary">
                Request a demo
              </Link>
              <Link to="/contact" className="btn btn--glass">
                Talk to sales
              </Link>
            </div>
            <div className="product-page-hero__audiences">
              {page.audiences.map((a) => (
                <span key={a} className="chip chip--product">
                  {a}
                </span>
              ))}
            </div>
          </div>
          <div className="product-page-hero__visual animate-in animate-in-delay-2">
            <img src={page.heroImage} alt="" />
          </div>
        </div>
      </section>

      <section className="section product-section">
        <div className="container product-overview">
          <div>
            <p className="section-header__label">Overview</p>
            <h2>Why {page.name}</h2>
          </div>
          <div className="product-overview__copy">
            {page.overview.map((para) => (
              <p key={para.slice(0, 40)}>{para}</p>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--band product-section">
        <div className="container">
          <p className="section-header__label">Capabilities</p>
          <h2 className="product-section__title">Built for production from day one</h2>
          <div className="feature-grid">
            {page.features.map((f) => (
              <article key={f.title} className="feature-card">
                <h3>{f.title}</h3>
                <p>{f.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section product-section">
        <div className="container product-split">
          <div>
            <p className="section-header__label">Platform</p>
            <h2>Core components</h2>
            <ul className="module-list">
              {page.modules.map((m) => (
                <li key={m.name}>
                  <strong>{m.name}</strong>
                  <span>{m.detail}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="section-header__label">At a glance</p>
            <h2>Technical highlights</h2>
            <table className="spec-table">
              <tbody>
                {page.specs.map(([k, v]) => (
                  <tr key={k}>
                    <th>{k}</th>
                    <td>{v}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="section section--band product-section">
        <div className="container">
          <p className="section-header__label">Use cases</p>
          <h2 className="product-section__title">Where teams deploy {page.name}</h2>
          <div className="use-case-grid">
            {page.useCases.map((uc) => (
              <article key={uc.title} className="use-case-card">
                <h3>{uc.title}</h3>
                <p>{uc.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CtaBand
        creative
        title={`See ${page.name} in action`}
        description="Schedule a tailored demo — we will walk through architecture, deployment options, and integration with your stack."
        primaryLabel="Request a demo"
        primaryHref={productDemoPath(page.id)}
        primaryExternal={false}
        secondaryLabel="Contact us"
        secondaryTo="/contact"
      />
    </>
  );
}
